<header class="panel-head">
  <div class="min-w-0">
    <ng-container [ngSwitch]="state.panel?.kind">
      <ng-container *ngSwitchCase="'suburb'">
        <div class="text-xl font-medium text-900 truncate">{{ detail.detail?.suburb?.name || 'Suburb' }}</div>
        <div class="text-500 text-sm">{{ detail.detail?.suburb?.state }} · ABS SAL {{ state.selectedCode }}<ng-container *ngIf="detail.detail?.suburb?.areaKm2"> · {{ detail.detail.suburb.areaKm2 | number: '1.0-2' }} km²</ng-container><ng-container *ngIf="detail.detail?.suburb?.lga"> · {{ detail.detail.suburb.lga }}</ng-container></div>
      </ng-container>
      <ng-container *ngSwitchCase="'place'">
        <a class="text-sm cursor-pointer place-back" (click)="nav.backToSuburb()"><i class="pi pi-arrow-left text-xs"></i> {{ detail.detail?.suburb?.name || 'Suburb' }}</a>
        <div class="text-xl font-medium text-900 truncate">{{ placeName }}</div>
      </ng-container>
      <ng-container *ngSwitchCase="'subregion'">
        <div class="text-xl font-medium text-900 truncate"><span class="swatch ring" [style.border-color]="catalogue.subRegionColour($any(state.panel).id)"></span>{{ catalogue.subRegionName($any(state.panel).id) }}</div>
        <div class="text-500 text-sm">sub-region of {{ catalogue.regionName(catalogue.subRegionRef($any(state.panel).id)?.regionId) }}</div>
      </ng-container>
      <div *ngSwitchCase="'regions'" class="text-xl font-medium text-900">Regions</div>
      <div *ngSwitchCase="'other-pages'" class="text-xl font-medium text-900">Places and other pages</div>
      <div *ngSwitchCase="'pending'" class="text-xl font-medium text-900">Waiting for review</div>
      <div *ngSwitchDefault class="text-xl font-medium text-900">{{ $any(state.panel)?.title }}</div>
    </ng-container>
  </div>
  <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-rounded flex-shrink-0" (click)="nav.closePanel()" aria-label="Close the panel"></button>
</header>

<nav *ngIf="state.panel?.kind === 'suburb'" class="panel-tabs">
  <button *ngFor="let t of tabs" type="button" [class.on]="$any(state.panel).tab === t.id" [hidden]="t.id === 'drafts' && !catalogue.pageOf(state.selectedCode)" (click)="nav.setTab(t.id)">
    {{ t.label }}<span *ngIf="t.id === 'notes' && notesCount" class="count">{{ notesCount }}</span>
  </button>
</nav>

<div class="panel-body">
  <!-- A content editor (page or region) mounts here, in place of the panel's own content. -->
  <ng-container #editorHost></ng-container>

  <ng-container *ngIf="!editor.open && state.panel as panel">
    <ng-container *ngIf="panel.kind === 'suburb'">
      <div *ngIf="detail.loading && !detail.detail" class="text-600">Loading…</div>
      <div *ngIf="detail.detail?.error" class="err">{{ detail.detail.error }}</div>
      <app-suburb-overview *ngIf="panel.tab === 'overview' && detail.detail && !detail.detail.error"></app-suburb-overview>
      <app-suburb-places-tab *ngIf="panel.tab === 'places'"></app-suburb-places-tab>
      <app-suburb-data-tab *ngIf="panel.tab === 'data' && detail.detail && !detail.detail.error" [detail]="detail.detail"></app-suburb-data-tab>
      <app-suburb-notes *ngIf="panel.tab === 'notes'" [salCode]="panel.salCode" [readOnly]="state.readOnly"></app-suburb-notes>
      <app-suburb-drafts *ngIf="panel.tab === 'drafts' && catalogue.pageOf(state.selectedCode)" [salCode]="panel.salCode" [readOnly]="state.readOnly"
                         [liveIntro]="publisher.selectedRecord?.intro || null" [liveBody]="publisher.selectedRecord?.body || null" (accepted)="publisher.draftAccepted($event)"></app-suburb-drafts>
      <!-- Page: the Page tab (page/content-suburb.component) mounts above; this shows when it can't. -->
      <ng-container *ngIf="panel.tab === 'page' && !editor.open">
        <div *ngIf="!state.selectedArea.regionId" class="text-600 text-sm">Put the suburb in a region first: its page lives under the region's address.</div>
        <div *ngIf="state.selectedArea.regionId && state.readOnly" class="text-600 text-sm">Pages are edited on a desktop.</div>
      </ng-container>
    </ng-container>

    <app-suburb-place *ngIf="panel.kind === 'place'" [locationId]="panel.locationId" [readOnly]="state.readOnly" (changed)="onPlaceChanged($event)"
                      (editCustom)="nav.editCustomPlace($event)"></app-suburb-place>

    <app-suburb-custom-place *ngIf="panel.kind === 'place-new' || panel.kind === 'place-edit'" [salCode]="panel.salCode"
                             [suburbName]="detail.name" [place]="panel.kind === 'place-edit' ? panel.place : null" [pin]="places.pin"
                             (saved)="nav.customSaved($event)" (cancelled)="nav.customCancelled()" (deleted)="nav.customDeleted()"></app-suburb-custom-place>

    <app-suburb-pending *ngIf="panel.kind === 'pending'" [readOnly]="state.readOnly" (count)="places.setPendingCount($event)"></app-suburb-pending>
    <app-suburb-regions-panel *ngIf="panel.kind === 'regions'"></app-suburb-regions-panel>
    <app-suburb-subregion-panel *ngIf="panel.kind === 'subregion'"></app-suburb-subregion-panel>
    <app-suburb-other-pages *ngIf="panel.kind === 'other-pages'"></app-suburb-other-pages>
  </ng-container>
</div>
